import { Spin } from "antd";
import { useEffect } from "react";
import { Providers } from "./app/providers";
import { AppRouter } from "./app/router";
import { authService } from "./modules/auth/services/auth.service";
import { useAuthStore } from "./modules/auth/store/auth.store";
import { ErrorBoundary } from "./shared/components/ErrorBoundary";
import { useOrganizationStore } from "./shared/store/organization.store";

function AuthInitializer({ children }: { children: React.ReactNode }) {
	const { hydrate, setUser, setLoading, logout, accessToken, isLoading } = useAuthStore();
	const clearOrganizations = useOrganizationStore((s) => s.clearOrganizations);

	useEffect(() => {
		const initAuth = async () => {
			hydrate();

			const currentToken = useAuthStore.getState().accessToken;
			if (currentToken) {
				try {
					const user = await authService.getMe();
					setUser(user);
				} catch {
					logout();
					clearOrganizations();
				}
			} else {
				setLoading(false);
			}
		};

		initAuth();
	}, [hydrate, setUser, setLoading, logout, clearOrganizations]);

	if (isLoading && accessToken) {
		return (
			<div className="min-h-screen flex items-center justify-center">
				<Spin size="large" />
			</div>
		);
	}

	return <>{children}</>;
}

function App() {
	return (
		<ErrorBoundary>
			<Providers>
				<AuthInitializer>
					<AppRouter />
				</AuthInitializer>
			</Providers>
		</ErrorBoundary>
	);
}

export default App;
